import * as React from 'react';

import Icon from 'components/Icon';
import Link from 'components/Link';
import Table from 'components/Table';
import EventTracking from 'lib/EventTracking';

import { AdminSchoolSisDashboard_organizations_sisSyncOverview_holdSummary_affectedResourcesSummary as AffectedResourceSummary } from 'admin/rostering/queries/__generated__/AdminSchoolSisDashboard';

import './styles/AdminSisSyncHoldViewResourceTable.scss';

type Props = {
  affectedResources: AffectedResourceSummary[];
  orgUuid: string;
};

const AdminSisSyncHoldViewResourceTable = ({ affectedResources, orgUuid }: Props) => {
  const handleLinkClicked = () => {
    EventTracking.track('rostering.hold.downloaded', {
      organization_uuid: orgUuid,
    });
  };

  return (
    <section className="AdminSisSyncHoldViewResourceTable">
      <Table
        actionsColumn
        head={
          <tr>
            <th>Count</th>
            <th>Description</th>
            <th>CSV</th>
          </tr>
        }>
        <tbody>
          {affectedResources.map(i => {
            return (
              <tr key={i.downloadUrl}>
                <td className="AdminSisSyncHoldViewResourceTable-firstColumn">{i.count}</td>
                <td>{i.description}</td>
                <td>
                  <Link
                    href={i.downloadUrl}
                    target="_blank"
                    tooltip="Download CSV"
                    tooltipPlacement="left"
                    download
                    onClick={handleLinkClicked}>
                    <Icon name="arrow-down-bar" size="large" />
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </section>
  );
};

export default AdminSisSyncHoldViewResourceTable;
